import { z } from 'zod';

export const SearchPdfToolName = 'searchPdf' as const;
export const searchPdfArgsSchema = z
  .object({
    url: z
      .string()
      .url()
      .describe(
        'Known HTTP(S) URL of a PDF from the user or tool results. For knowledge-base documents use documentSearch with documentIds instead.',
      ),
    queries: z
      .array(z.string().trim().min(1).max(200))
      .min(1)
      .max(10)
      .describe(
        'Up to ten literal phrase variations, matched ignoring case, accents and whitespace. No regex or semantic search.',
      ),
    maxResults: z
      .number()
      .int()
      .min(1)
      .max(10)
      .nullish()
      .describe('Maximum expanded passages, default 5.'),
    contextChars: z
      .number()
      .int()
      .min(100)
      .max(800)
      .nullish()
      .describe('Characters around each match, default 400.'),
  })
  .strict();
